import type { QueryClient } from "@tanstack/react-query";

import { queryKeys } from "./queryKeys";

type OrderRelatedQueryClient = Pick<QueryClient, "invalidateQueries">;

export const invalidateOrderRelatedQueries = (
  queryClient: OrderRelatedQueryClient,
) => {
  queryClient.invalidateQueries({ queryKey: queryKeys.orders.all });
  queryClient.invalidateQueries({ queryKey: queryKeys.positions.all });
};
